<div class="container">
  <div class="row pb-3 ms-3 mr-3 mt-3 justify-content-end">
    <div class="col-auto">
      <button [routerLink]="'portfolio-create/select'" (click)="onNewPortfolio()" type="button" class="mb-3 add-button" mat-flat-button color="primary">
        <span class="navigation-button">New portfolio</span>
      </button>
    </div>
    <div class="col-auto">
    <app-file-uploader
              (uploadEvent)="onUploadEvent($event)"
              [isUploading]="isUploading"
              [acceptLabel]="'xls'"
              [accept]="'.xlsx'"
      ></app-file-uploader>
    </div>
  </div>

</div>
<div class="ms-3 mr-3">
  <app-portfolio-table [needPagination]="false" title="My Portfolios" [list]="lists.private" [visibleShareUser]="false" (forkPortfolio)="forkItem($event)"></app-portfolio-table>
</div>